'use strict'
import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'

import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

import { AgGridReact } from 'ag-grid-react'
import { Button, Icon } from 'antd'
import { Toolbar } from 'primereact/toolbar'

import AddNewButton from '../../components/CustomButtons/addNewButton'
import ExportButton from '../../components/CustomButtons/exportGreenButton'
import GlobalSearchInput from '../../components/CustomGlobalSearchInput/globalSearchInput'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

class ListDistrict extends React.Component {
  constructor(props) {
    super(props)
    this.gridApi = null
    this.gridColumnApi = null

    this.state = {
      columnDefs: [
        { headerName: 'Distrito', field: 'name', width: 80, filter: 'agTextColumnFilter' },
        { headerName: 'Região', field: 'regionName', width: 30, filter: 'agTextColumnFilter' },
        {
          headerName: 'Editar',
          field: 'id',
          width: 9,
          sortable: false,
          resizable: false,
          cellRenderer: this.actionCellRenderer
        }
      ],
      defaultColDef: {
        sortable: true,
        resizable: true,
        minWidth: 1,
        width: 100,
        floatingFilter: true
      },
      rowData: []
    }
  }

  async listDistrict() {
    try {
      const data = await request(api.listDistrict())
      return data
    } catch (error) {
      console.error('Error getting district:', error)
      return []
    }
  }

  onGridReady = (params) => {
    this.gridApi = params.api
    this.gridColumnApi = params.columnApi

    this.gridApi.sizeColumnsToFit()

    this.listDistrict().then((data = []) => {
      this.setState({ rowData: data })
    })
  }

  renderHeader() {
    const leftContents = (
      <h2>
        <b>Listas de Distritos</b>
      </h2>
    )

    const rightContents = (
      <div className="container-header-lists">
        <GlobalSearchInput
          value={this.state.value3}
          onChange={(e) => this.gridApi?.setGridOption('quickFilterText', e.target.value)}
        />

        <div>
          <ExportButton
            iconType="csv"
            label={getMessage('label.exportCvs')}
            onClick={() => this.gridApi && this.gridApi.exportDataAsCsv()}
          />
          <AddNewButton
            label={getMessage('createDistrict')}
            onClick={() => this.props.history.push(`/district/create`)}
          />
        </div>
      </div>
    )

    return <Toolbar start={leftContents} end={rightContents} />
  }

  render() {
    return (
      <>
        {this.renderHeader()}
        <div style={{ width: '100%', height: '70vh' }} className="ag-theme-alpine">
          <AgGridReact
            columnDefs={this.state.columnDefs}
            defaultColDef={this.state.defaultColDef}
            onGridReady={this.onGridReady}
            rowData={this.state.rowData}
            rowSelection="single"
            getRowStyle={(params) => ({
              color: params.data && params.data.active ? 'inherit' : 'gray'
            })}
          />
        </div>
      </>
    )
  }

  actionCellRenderer(params) {
    return (
      <Link to={`/district/${params.value}`}>
        <Button
          type="ghost"
          style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', border: 'none' }}
        >
          <Icon type="edit" size="small" />
        </Button>
      </Link>
    )
  }
}

export default withRouter(ListDistrict)
